module.exports = __webpack_public_path__ + "img/7.65099615.png";